import * as React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

import { convertTableData } from '../utils/formatCells';

const DataTable = (props) => {
  const { data, width, height } = props;
  
  const unit = sessionStorage.getItem("numberUnit") || 3;
  const separator = sessionStorage.getItem("numberSeparator") || ",";
  const decimalPlace = sessionStorage.getItem("decimalPlace") || 2;
  
  const numberWithCommas = (number) => {
    const converted = number.toFixed(decimalPlace);
    const regex = new RegExp('\\B(?=(\\d{' + unit + '})+(?!\\d))', 'g');
    return converted.replace(regex, separator);
  };

  const numberNoDecimals = (number) => {
    const regex = new RegExp('\\B(?=(\\d{' + unit + '})+(?!\\d))', 'g');
    return Math.round(number).toString().replace(regex, separator);
  };

  const table = convertTableData(data, numberWithCommas, numberNoDecimals);
  const headers = Object.keys(table[0]);

  return (
    <Box sx={{height: height?`${height}px`: 'auto', width: width?`${width}px`: 'auto'}}>
      <TableContainer className='w-full h-full' component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {
                headers.map((item, index) => (<TableCell sx={{fontWeight: 600}} key={index}>{item}</TableCell>))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {table.map((row, index) => (
              <TableRow key={index}>
                {headers.map((column) => (
                  <TableCell key={column}>
                    {row[column] == null ? '' : typeof row[column] === 'object' ? JSON.stringify(row[column]) : row[column]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DataTable;